<template>
  <div id="app" class="list-container">
    <div>
      <GlobalLoader />
      <p class="mt-3 text-semibold">Please be patient ! We are setting up your organization</p>
    </div>
  </div>
</template>

<script>
import store from "@/store/index";
import Vue from "vue";

export default {
  methods: {
    async fetchSession() {
      var admin = this.$route.query.admin == "true" ? 1 : 0;
      //  get organization details from fetch sesssion store
      // const { data, org_details } = await store.dispatch("session/fetchSession", admin);
      //  set the session id  to the cookie by using following function
      await store.dispatch("session/fetchSession", admin).then(async (response) => {
        await store.dispatch("session/setSession", {
          session_id: response.data,
          admin: admin,
        });
        //  set the global data
        window.meta = store.state.session.org_details;
      });

      Vue.prototype.$AppDetails = window.meta;
      //  chnage the path of the application
      const currentPath = window.location.pathname;
      if (currentPath === "/" || currentPath === "/index") {
        var routeTo = this.$route.query.redirect || "/app/home/dashboard";
        this.$router.push(routeTo);
      }
    },
  },
  created() {
    this.fetchSession();
  },
};
</script>
